module.exports = __webpack_public_path__ + "img/blue-bg.af6cd925.png";